module.exports = __webpack_public_path__ + "static/media/Svgpic.bbe06f39.svg";